import React, { useState } from 'react';
import './SpecialisedForm.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function SpecialisedForm({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: '', phone: '', email: '', institution: '',
    programme: '', techInterest: '', customTech: '',
    startDate: '', goals: '', hardware: '',
    source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.institution) newErrors.institution = 'Institution is required';
    if (!formData.techInterest) newErrors.techInterest = 'Please select your technology interest';
    if (!formData.goals) newErrors.goals = 'Please describe what you want to build';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  setTimeout(() => {
    const firstError = document.querySelector('.error-field');
    if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 100);
  return;
}

    try {
      await fetch('http://localhost:5000/api/centre', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
  name:        formData.fullName,
  type:        'College',
  phone:       formData.phone,
  email:       formData.email,
  institution: formData.institution,
  grade:       formData.programme || '',
  mode:        'Offline',
  formType:    'Specialised Programme',
  techInterest: formData.techInterest === 'other' ? formData.customTech : formData.techInterest,
  startDate:   formData.startDate || '',
  goals:       formData.goals || '',
  hardware:    formData.hardware || '',
  source:      formData.source === 'Other' ? formData.customSource : formData.source,
}),
      });
      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="sf__overlay" onClick={onClose}>
        <div className="sf__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your specialised course request. Our team will review your requirements and get back to you within <strong>24–48 hours</strong> with a tailored course plan.</p>
          <button className="sf__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="sf__overlay" onClick={onClose}>
      <div className="sf__box" onClick={(e) => e.stopPropagation()}>

        <button className="sf__close" onClick={onClose}>✕ Close</button>
        <h2 className="sf__title">Specialised Course — Custom Configuration Request</h2>
        <p className="sf__subtitle">Tell us what you want to build. We will design a course specifically around your goals and hardware preference.</p>

        <div className="sf__info-box">
          <p className="sf__info-title">✨ WHAT IS A SPECIALISED COURSE?</p>
          <p className="sf__info-desc">A specialised course at ibots is a customised training program based on student interests, focused on practical, hands-on learning.</p>
        </div>

        <h3 className="sf__form-title">Submit Your Requirements</h3>

        <div className="sf__form">
          <div className="sf__row">
            <div className="sf__group">
              <label className="sf__label">Full Name *</label>
              <input type="text" name="fullName" value={formData.fullName}
                onChange={handleChange} placeholder="Enter your full name" className="sf__input" />
              {errors.fullName && <p style={errStyle} className="error-field">{errors.fullName}</p>}
            </div>
            <div className="sf__group">
              <label className="sf__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="sf__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
          </div>

          <div className="sf__row">
            <div className="sf__group">
              <label className="sf__label">Email Address *</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="you@example.com" className="sf__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
            <div className="sf__group">
              <label className="sf__label">Institution Name *</label>
              <input type="text" name="institution" value={formData.institution}
                onChange={handleChange} placeholder="College / University name" className="sf__input" />
              {errors.institution && <p style={errStyle} className="error-field">{errors.institution}</p>}
            </div>
          </div>

          <div className="sf__row">
            <div className="sf__group">
              <label className="sf__label">Programme & Year</label>
              <input type="text" name="programme" value={formData.programme}
                onChange={handleChange} placeholder="e.g. B.E. ECE, 3rd Year" className="sf__input" />
            </div>
            <div className="sf__group">
              <label className="sf__label">Primary Technology Interest *</label>
              <select name="techInterest" value={formData.techInterest}
                onChange={handleChange} className="sf__input sf__select">
                <option value="">Select main area...</option>
                <option value="ai-vision">AI with Raspberry Pi (Computer Vision)</option>
                <option value="ai-camera">AI with Raspberry Pi + Camera Module</option>
                <option value="drone">Drone Technology (Advanced)</option>
                <option value="iiot">Industrial IoT (IIoT)</option>
                <option value="mechatronics">Mechatronics & Robotics</option>
                <option value="stm32">STM32 & ARM Development</option>
                <option value="ai-embedded">AI + Embedded Systems Combination</option>
                <option value="custom">Custom Combination (specify below)</option>
              </select>
              {errors.techInterest && <p style={errStyle} className="error-field">{errors.techInterest}</p>}
              {formData.techInterest === 'custom' && (
                <input type="text" name="customTech" value={formData.customTech}
                  onChange={handleChange} placeholder="Describe your custom combination..."
                  className="sf__input sf__input--mt" />
              )}
            </div>
          </div>

          <div className="sf__group sf__group--full">
            <label className="sf__label">Preferred Start Date</label>
            <input type="text" name="startDate" value={formData.startDate}
              onChange={handleChange} placeholder="e.g. June 2025" className="sf__input" />
          </div>

          <div className="sf__group sf__group--full">
            <label className="sf__label">What do you want to build / achieve? *</label>
            <textarea name="goals" value={formData.goals} onChange={handleChange}
              placeholder="Describe your project idea, learning goal, or what you want to create..."
              className="sf__input sf__textarea" />
            {errors.goals && <p style={errStyle} className="error-field">{errors.goals}</p>}
          </div>

          <div className="sf__group sf__group--full">
            <label className="sf__label">Any specific hardware / tools in mind? (optional)</label>
            <input type="text" name="hardware" value={formData.hardware}
              onChange={handleChange}
              placeholder="e.g. Raspberry Pi 4, Camera Module, Servo Motors, specific sensors..."
              className="sf__input" />
          </div>

          <div className="sf__group sf__group--full">
            <label className="sf__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="sf__input sf__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="sf__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <div className="sf__contact-note">
            Our team will review your requirements and get back within <strong>24–48 hours</strong> with a tailored course plan and pricing. Contact: 📞 <strong>+91 9442717713</strong> · 📧 <strong>info@ibots.in</strong>
          </div>

          <button className="sf__submit" onClick={handleSubmit}>
            Submit Custom Course Request →
          </button>
        </div>
      </div>
    </div>
  );
}

export default SpecialisedForm;